
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import CompanyTable from '../components/company_auth_table.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'enterprise-auth',
    components: {
        CompanyTable,
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private companyList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private isLoading = false
    private loadingText = ''
    private status = -1
    private statusOptions = [
        { label: '所有申请', value: -1 },
        { label: '审核中', value: 0 },
        { label: '通过', value: 1 },
        { label: '不通过', value: 2 }
    ]


    private async mounted() {
        this.getCompanyList()
    }

    /** 获取机构认证申请列表 */ 
    private async getCompanyList() {
        const status = this.status === -1 ? undefined : this.status
        const params = {
            status: status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.showLoading()
        const result = await EnterpriseService.getCompanyAuthList(params)
        this.hideLoading()
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.companyList = result.data.list
        }
    }   

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getCompanyList)
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
